import { useQuery } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import { queryKeys } from "../../query-keys";

export function useDisputes(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.disputes(clubId ?? ""),
		queryFn: () => financeApi.disputes.list(clubId!),
		enabled: !!clubId,
	});
}
